import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  lumi_store_id: yup.string().required("Lumi store is required"),
  marketplace_store_ref: yup.string().required("Chowdeck store is required"),
});

export const useValidation = ({ ...rest }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...rest,
    },
  });
};
